var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioRightNavSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80mm",
    height: "10.820578mm",
    viewBox: "0 0 80 10.82058",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0725972
    },
    id: "rect4",
    width: 79.927406,
    height: 0.027402779,
    x: 0.03629861,
    y: 10.731315
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0540059
    },
    id: "rect4-30",
    width: 10.661049,
    height: 0.1136923,
    x: 0.027002949,
    y: -40.141644,
    transform: "rotate(90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioRightNavSvg);
export default __webpack_public_path__ + "static/media/portfolio_right_nav_svg.15c4c1b3898d9c9683b16ee93d0f6914.svg";
export { ForwardRef as ReactComponent };